import { displayRefinement } from '../../utils/common';
import { FluxTag } from '../tag';

export interface Refinement extends FluxTag<any> { }

export class Refinement {

  ref: any;
  nav: any;
  toView: typeof displayRefinement;

  init() {
    this._scopeTo('gb-navigation');
    this.toView = displayRefinement;
  }
}

export class AvailableRefinement extends Refinement {
  send() {
    return this._scope.send(this.ref, this.nav);
  }
}

export class SelectedRefinement extends Refinement {
  remove() {
    return this._scope.remove(this.ref, this.nav);
  }
}



/** WEBPACK FOOTER **
 ** ./~/source-map-loader!./src/tags/navigation/gb-refinement.ts
 **/